import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mobile",
  "use": "mobile-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 12\" id=\"mobile\">\n    <g fill-rule=\"evenodd\">\n        <path fill-opacity=\".45\" d=\"M11 2.333c.552 0 1 .448 1 1v9.334c0 .552-.448 1-1 1H5c-.552 0-1-.448-1-1V3.333c0-.552.448-1 1-1h6zm0 1H5v9.334h6V3.333zm-3 7.334c.238 0 .458.127.577.333.12.206.12.46 0 .667-.119.206-.339.333-.577.333-.368 0-.667-.299-.667-.667 0-.368.299-.666.667-.666zm1.333-6.834v1H6.667v-1h2.666z\" transform=\"translate(-4 -2)\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol